import script from "./ViewAttendanceBulkEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAttendanceBulkEdit.vue?vue&type=script&setup=true&lang=js"

import "./ViewAttendanceBulkEdit.vue?vue&type=style&index=0&id=21c39b6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c39b6e"]])

export default __exports__